import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { BLUE_LIGHT, SECONDARY_GREY, HEADING } from "src/constants/colors";
import { INVITE_BG_GRADIENT } from "src/constants/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  box-sizing: border-box;
  text-align: center;
  background: ${INVITE_BG_GRADIENT};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 80px;
  border-bottom: 1px solid ${SECONDARY_GREY};
  margin-bottom: 43px;
`;

export const HeaderDescription = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: ${HEADING};
  letter-spacing: -0.6%;
`;

export const Body = styled.div`
  display: flex;
  align-self: center;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  width: 564px;
`;

export const Title = styled.h1`
  width: 394px;
  font-size: 75px;
  color: ${HEADING};
  font-weight: 600;
  font-size: 28px;
  leading-trim: Cap height;
  line-height: 130%;
  letter-spacing: -0.6%;
  text-align: center;
  margin-bottom: 30px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

export const PorchPassLogo = styled.div`
  width: 130px;
  height: 32px;
  margin: 0 auto 40px auto;
`;

export const LogoLink = styled(Link)`
  text-decoration: none;

  & > img {
    max-height: 32px;
    max-width: 130px;
  }
`;

export const Section = styled.div<{ disabled?: boolean }>`
  position: relative;
  display: ${({ disabled }) => (disabled ? "none" : "flex")};
  flex-direction: column;
  gap: 28px;
  width: 100%;
  text-align: left;
  margin-bottom: 40px;
`;

export const SectionHeading = styled.h3`
  font-size: 14px;
`;

export const IconWrapper = styled.div`
  display: inline-flex;
  padding: 4px 6px;
  align-items: center;
  gap: 8px;
  border-radius: 24px;
  background: ${BLUE_LIGHT};
`;
